import { Box, styled } from '@mui/material';

export const DBoxContainer = styled(Box)(() => ({
  margin: '0 auto',

  display: 'flex',
  flexDirection: 'row',
  columnGap: '48px',

  '@media screen and (max-width: 1280px)': {
    columnGap: '24px',
  },

  '@media screen and (max-width: 640px)': {
    flexDirection: 'column',
    columnGap: 0,
    rowGap: '24px',
  },
}));
